import React from "react"
import styled from "styled-components"

const Underlined = styled.div`
  width: 5rem;
  height: 0.25rem;
  margin-bottom: 0.75rem;
  background: var(--clr-primary-5);
  margin-left: auto;
  margin-right: auto;
`
const Wrapper = styled.div`
  padding: 6.5rem 0 2.5rem 0;
  width: 100%;
  margin: 0 auto;
  max-width: 1170px;
  font-family: "Quicksand", sans-serif;

  h2 {
    margin-bottom: 1rem;
    text-align: center;
    font-size: 2rem;
  }
  @media screen and (min-width: 992px) {
    width: 95%;
  }
`

const Title = ({ title }) => {
  return (
    <Wrapper>
      <h2>{title || "default title"}</h2>
      <Underlined />
    </Wrapper>
  )
}

export default Title
